import {
  GET_PROXIES_REQUEST,
  GET_PROXIES_REQUEST_SUCCESS,
  GET_PROXIES_REQUEST_FAILURE,
  GET_PROXY_SETTINGS_REQUEST,
  GET_PROXY_SETTINGS_REQUEST_SUCCESS,
  GET_PROXY_SETTINGS_REQUEST_FAILURE,
  UPDATE_PROXY_SETTING_REQUEST,
  UPDATE_PROXY_SETTING_REQUEST_SUCCESS,
  UPDATE_PROXY_SETTING_REQUEST_FAILURE,
  ADD_PROXY_REQUEST,
  ADD_PROXY_REQUEST_SUCCESS,
  ADD_PROXY_REQUEST_FAILURE,
  DELETE_PROXY_REQUEST,
  DELETE_PROXY_REQUEST_SUCCESS,
  DELETE_PROXY_REQUEST_FAILURE,
  REFRESH_PROXY_REQUEST,
  REFRESH_PROXY_REQUEST_SUCCESS,
  REFRESH_PROXY_REQUEST_FAILURE,
} from "./mutation-types";

const mutations = {
  [GET_PROXIES_REQUEST]: (state) => {
    state.isRequesting = true;
  },
  [GET_PROXIES_REQUEST_SUCCESS]: (state, payload) => {
    state.proxies = payload;
    state.isRequesting = false;
  },
  [GET_PROXIES_REQUEST_FAILURE]: (state) => {
    state.isRequesting = false;
  },

  [GET_PROXY_SETTINGS_REQUEST]: (state) => {
    state.isRequesting = true;
  },
  [GET_PROXY_SETTINGS_REQUEST_SUCCESS]: (state, payload) => {
    state.settings = payload;
    state.isRequesting = false;
  },
  [GET_PROXY_SETTINGS_REQUEST_FAILURE]: (state) => {
    state.isRequesting = false;
  },

  [UPDATE_PROXY_SETTING_REQUEST]: (state) => {
    state.isRequesting = true;
  },
  [UPDATE_PROXY_SETTING_REQUEST_SUCCESS]: (state, payload) => {
    state.settings = payload;
    state.isRequesting = false;
  },
  [UPDATE_PROXY_SETTING_REQUEST_FAILURE]: (state) => {
    state.isRequesting = false;
  },

  [ADD_PROXY_REQUEST]: (state) => {
    state.isRequesting = true;
  },
  [ADD_PROXY_REQUEST_SUCCESS]: (state, payload) => {
    state.proxies = payload;
    state.isRequesting = false;
  },
  [ADD_PROXY_REQUEST_FAILURE]: (state) => {
    state.isRequesting = false;
  },

  [DELETE_PROXY_REQUEST]: (state) => {
    state.isRequesting = true;
  },
  [DELETE_PROXY_REQUEST_SUCCESS]: (state, payload) => {
    state.proxies = payload;
    state.isRequesting = false;
  },
  [DELETE_PROXY_REQUEST_FAILURE]: (state) => {
    state.isRequesting = false;
  },

  [REFRESH_PROXY_REQUEST]: (state) => {
    state.isRequesting = true;
  },
  [REFRESH_PROXY_REQUEST_SUCCESS]: (state, payload) => {
    state.proxies = payload;
    state.isRequesting = false;
  },
  [REFRESH_PROXY_REQUEST_FAILURE]: (state) => {
    state.isRequesting = false;
  },
};

export default mutations;
